import { render, staticRenderFns } from "./WechatResponse.vue?vue&type=template&id=10ec4981&scoped=true"
import script from "./WechatResponse.vue?vue&type=script&lang=js"
export * from "./WechatResponse.vue?vue&type=script&lang=js"
import style0 from "./WechatResponse.vue?vue&type=style&index=0&id=10ec4981&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ec4981",
  null
  
)

export default component.exports